import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import SearchInput from 'assets/components/inputs/search/SearchInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import { getLocales } from 'assets/locales/Locale';
import { defaultInputDateTimeFormat } from 'assets/utils/data/Date';
import { isDesktop } from 'react-device-detect';
import { useClaimProvider } from '../Claim.Hooks';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';

export default function ClaimFilters() {
  const { lang } = getLocales();
  const { listApi, productsApi, dealersApi, userApi, vehicleMakeApi, statuses, pageRouter } = useClaimProvider();
  const { isDealer } = useAuthStore();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      filters={listApi?.body}
      onFilter={(newFilters) => listApi?.execute(newFilters)}
      onReset={() => {
        pageRouter.redirect(
          { ...pageRouter.params, action: undefined },
          {
            ...pageRouter.query,
            list: undefined,
          }
        );
      }}
      inline={isDesktop}
      onOpen={() => {
        if (!productsApi?.payload) productsApi?.execute();
        if (!vehicleMakeApi?.payload) vehicleMakeApi?.execute();
        if (!userApi?.payload) userApi?.execute();
        if (!dealersApi?.payload && !isDealer) dealersApi?.execute((b) => b);
      }}
      actions={
        <SearchInput
          value={listApi?.body?.search}
          onSearch={(search) => listApi?.execute((body) => ({ ...body, search }))}
          threshold={2}
          placeholder={`${lang.search}...`}
        />
      }
      render={({ tempFilters, setFilters }) => (
        <>
          <SelectInput
            name="statusCode"
            label={lang.status}
            data={statuses}
            isMultiselect
            disableTags={isDesktop}
            value={tempFilters?.statusCode}
            onChange={({ statusCode }) => setFilters({ ...tempFilters, statusCode })}
            icon={<Icon class="fas-check" />}
          />
          <SelectInput
            name="makeId"
            label={lang.vehicleMakes}
            data={vehicleMakeApi?.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-car" />,
            }))}
            isMultiselect
            disableTags={isDesktop}
            value={tempFilters?.makeId}
            onChange={({ makeId }) => setFilters({ ...tempFilters, makeId })}
            icon={<Icon class="fas-car" />}
          />
          <SelectInput
            name="productId"
            label={lang.products}
            data={productsApi?.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-box" />,
            }))}
            isMultiselect
            disableTags={isDesktop}
            value={tempFilters?.productId}
            onChange={({ productId }) => setFilters({ ...tempFilters, productId })}
            icon={<Icon class="fas-box" />}
          />
          <SelectInput
            name="dealerId"
            label={lang.dealers}
            data={dealersApi?.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-user-friends" />,
            }))}
            isMultiselect
            disableTags={isDesktop}
            value={tempFilters?.dealerId}
            onChange={({ dealerId }) => setFilters({ ...tempFilters, dealerId })}
            icon={<Icon class="fas-user-friends" />}
            disabled={isDealer}
          />
          <SelectInput
            name="ownerId"
            label={lang.owner}
            data={userApi?.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-user" />,
            }))}
            isMultiselect
            disableTags={isDesktop}
            value={tempFilters?.ownerId}
            onChange={({ ownerId }) => setFilters({ ...tempFilters, ownerId })}
            icon={<Icon class="fas-user" />}
          />
          <InputWrapper style={{ gridColumn: 'span 2', height: 'fit-content', marginTop: 'var(--sizeM)' }}>
            <DateInput
              name="startDateUtc"
              label={lang.startDate}
              dateTimeFormat={defaultInputDateTimeFormat}
              value={tempFilters?.startDateUtc}
              onChange={({ startDateUtc }) => setFilters({ ...tempFilters, startDateUtc })}
              icon={<Icon class="fas-calendar-alt" />}
            />
            <DateInput
              name="endDateUtc"
              label={lang.endDate}
              dateTimeFormat={defaultInputDateTimeFormat}
              value={tempFilters?.endDateUtc}
              onChange={({ endDateUtc }) => setFilters({ ...tempFilters, endDateUtc })}
              icon={<Icon class="fas-calendar-alt" />}
            />
          </InputWrapper>
        </>
      )}
    />
  );
}
